import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useAcademicsService } from '../../../../apis/academics/useAcademicsService';
import { IAcademicsCourseResponse } from '../../../../apis/academics/academics.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getAcademicsCoursesKey = 'get-academics-courses';

export type TAcademicsCoursesParams = {
  page?: number;
  limit?: number;
  academicYear?: string;
  search?: string;
};

export const useAcademicsCoursesHook = (
  params: TAcademicsCoursesParams,
  options?: UseQueryOptions<IAcademicsCourseResponse, TQueryError>
): UseQueryResult<IAcademicsCourseResponse, TQueryError> => {
  const { getAcademicsCourses } = useAcademicsService();

  return useQuery<IAcademicsCourseResponse, TQueryError>({
    queryKey: [getAcademicsCoursesKey, params],
    queryFn: () => getAcademicsCourses(params),
    enabled: true,
    ...options,
  });
};
